 <div style="margin-left: 80%; margin-bottom: 2%;">
        <button   id="print-button"  class="noPrint" style="margin-top: 2%; margin-left: 2%; display: none; " mat-raised-button color="primary"
        printSectionId="print-section1"  [useExistingCss]="true"  ngxPrint>
      Print
      </button>

      <button (click)="printPage()" class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary">
    Print
    </button>
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" (click)="exportExcel('Advt_Invoice_Register')"
            mat-raised-button color="primary">
            Export
        </button>
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>  

<!-- Report Section -->
<div class="container"  id="print-section1" style="margin-top: 50px; margin-right: 3px; margin-left: 3px;">
  <table class="table table-bordered" style="width: 100%; border-collapse: collapse;">
    <thead>
      <tr>
        <th colspan="6" style="font-size: medium;">
          हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - जाहिरात विभाग - Advt Invoice Register
        </th>
        <th colspan="2" style="font-size: medium;">Briefly Officer</th>
        <th colspan="5" style="font-size: medium;">दिनांक - {{ today | date: "dd-MM-yyyy" }}</th>
        <th colspan="3" style="font-size: medium;">पृष्ठ क्र.- 1</th>
      </tr>
      <tr>
        <th colspan="8" class="leftAlign"></th>
        <th colspan="4" class="leftAlign">
          <div>Issue Date :</div>
        </th>
        <th colspan="4" class="leftAlign" style="font-size: medium;">
          <div>Date : From : {{ startDate | date: "dd-MM-yyyy" }} To : {{ endDate | date: "dd-MM-yyyy" }}</div>
        </th>
      </tr>
      <tr>
        <th rowspan="2" style="font-size: 14px; text-align: center;">Invoice No.</th>
        <th rowspan="2" style="font-size: 14px; text-align: center;">Invoice<br />Date</th>
        <th rowspan="2" style="font-size: 14px; text-align: center;">Advertiser Name</th>
        <th rowspan="2" style="font-size: 14px; text-align: center;">Customer <br />Name</th>
        <th rowspan="2" style="font-size: 14px; text-align: center;">Issue<br>Name</th>
        <th rowspan="2" style="font-size: 14px; text-align: center;">Issue<br>Date</th>
        <th rowspan="2" style="font-size: 14px; text-align: center;">Advt. <br />Amount</th>
        <th rowspan="2" style="font-size: 14px; text-align: center;">Discount <br />Amount</th>
        <th rowspan="2" style="font-size: 14px; text-align: center;">Amount<br />before GST</th>
        <th rowspan="2" style="font-size: 14px; text-align: center;">CGST</th>
        <th rowspan="2" style="font-size: 14px; text-align: center;">SGST</th>
        <th rowspan="2" style="font-size: 14px; text-align: center;">IGST</th>
        <th rowspan="2" style="font-size: 14px; text-align: center;">Total<br>GST</th>
        <th rowspan="2" style="font-size: 14px; text-align: center;">Total Invoice <br />Amount</th>
        <th rowspan="2" style="font-size: 14px; text-align: center;">Paid <br />Amount</th>
        <th rowspan="2" style="font-size: 14px; text-align: center;">Unpaid<br />Amount</th>
      </tr>
    </thead>

    <tbody>
      <!-- Group by Office Representative -->
      <ng-container *ngFor="let officeGroup of filteredAdvtInvoiceData">
        <!-- Office Representative Header -->
        <tr>
          <td colspan="16" style="font-weight: bold; font-size: 16px; background: #97daee; text-align: left;">
            Office Representative : {{ officeGroup.off_rep_name }}
          </td>
        </tr>

        <!-- Loop through Representatives -->
        <ng-container *ngFor="let repGroup of officeGroup.representatives">
          <!-- Representative Header -->
          <tr>
            <td colspan="16"
              style="font-weight: bold; font-size: 14px; background: #8496e7; padding-left: 25px; text-align: left;">
              Representative : {{ repGroup.rep_name }}
            </td>
          </tr>

          <!-- Invoice Rows -->
          <ng-container *ngFor="let data of repGroup.data">
            <tr>
              <td>{{ data['invoice_no'] }}</td>
              <td>{{ data['invoice_date'] }}</td>
              <td style="font-weight: bold;">{{ data['advt_name'] | slice: 0:30 }}</td>
              <td>{{ data['cust_name'] }}</td>
              <td>{{ data['combined_issue_name'] | slice: 0:20 }}</td>
              <td>{{ data['combined_issue_date'] }}</td>
              <td style="text-align: end;">{{ data['advt_amt'] }}</td>
              <td style="text-align: end;">{{ data['discount'] }}</td>
              <td style="text-align: end;">{{ data['beforegst_amt'] }}</td>
              <td style="text-align: end;">{{ data['cgst'] }}</td>
              <td style="text-align: end;">{{ data['sgst'] }}</td>
              <td style="text-align: end;">{{ data['igst'] }}</td>
              <td style="text-align: end;">{{ data['gst'] }}</td>
              <td style="text-align: end;">{{ data['invoice_total'] }}</td>
              <td style="text-align: end;">{{ data['received_amt'] }}</td>
              <td style="text-align: end;">{{ data['unpaid_amount'] }}</td>
            </tr>
          </ng-container>

          <!-- Representative Total -->
          <tr style="background: #e8f4f8;">
            <td colspan="6" style="font-weight: bold; border: 1px solid #000;">Representative Total ({{
              repGroup.rep_name }})</td>
            <td style="text-align: end; font-weight: bold; border: 1px solid #000;">{{ repGroup.rep_advt_amt }}</td>
            <td style="text-align: end; font-weight: bold; border: 1px solid #000;">{{ repGroup.rep_discount }}</td>
            <td style="text-align: end; font-weight: bold; border: 1px solid #000;">{{ repGroup.rep_beforegst_amt }}
            </td>
            <td style="text-align: end; font-weight: bold; border: 1px solid #000;">{{ repGroup.rep_cgst }}</td>
            <td style="text-align: end; font-weight: bold; border: 1px solid #000;">{{ repGroup.rep_sgst }}</td>
            <td style="text-align: end; font-weight: bold; border: 1px solid #000;">{{ repGroup.rep_igst }}</td>
            <td style="text-align: end; font-weight: bold; border: 1px solid #000;">{{ repGroup.rep_gst }}</td>
            <td style="text-align: end; font-weight: bold; border: 1px solid #000;">{{ repGroup.rep_invoice_total }}
            </td>
            <td style="text-align: end; font-weight: bold; border: 1px solid #000;">{{ repGroup.rep_paid_amt }}</td>
            <td style="text-align: end; font-weight: bold; border: 1px solid #000;">{{ repGroup.rep_unpaid_amt }}</td>
          </tr>
        </ng-container>

        <!-- Office Representative Total -->
        <tr style="background: #d4edff;">
          <td colspan="6" style="font-weight: bold; border: 2px solid #000;">Office Representative Total ({{
            officeGroup.off_rep_name }})</td>
          <td style="text-align: end; font-weight: bold; border: 2px solid #000;">{{ officeGroup.office_advt_amt }}</td>
          <td style="text-align: end; font-weight: bold; border: 2px solid #000;">{{ officeGroup.office_discount }}</td>
          <td style="text-align: end; font-weight: bold; border: 2px solid #000;">{{ officeGroup.office_beforegst_amt }}
          </td>
          <td style="text-align: end; font-weight: bold; border: 2px solid #000;">{{ officeGroup.office_cgst }}</td>
          <td style="text-align: end; font-weight: bold; border: 2px solid #000;">{{ officeGroup.office_sgst }}</td>
          <td style="text-align: end; font-weight: bold; border: 2px solid #000;">{{ officeGroup.office_igst }}</td>
          <td style="text-align: end; font-weight: bold; border: 2px solid #000;">{{ officeGroup.office_gst }}</td>
          <td style="text-align: end; font-weight: bold; border: 2px solid #000;">{{ officeGroup.office_invoice_total }}
          </td>
          <td style="text-align: end; font-weight: bold; border: 2px solid #000;">{{ officeGroup.office_paid_amt }}</td>
          <td style="text-align: end; font-weight: bold; border: 2px solid #000;">{{ officeGroup.office_unpaid_amt }}
          </td>
        </tr>
      </ng-container>

      <!-- Grand Total -->
      <tr>
        <td colspan="6" style="font-weight: bold; border: 1px solid #000;">Total</td>
        <td style="text-align: end; font-weight: bold; border: 1px solid #000;">{{ advtamount }}</td>
        <td style="text-align: end; font-weight: bold; border: 1px solid #000;">{{ discountamt }}</td>
        <td style="text-align: end; font-weight: bold; border: 1px solid #000;">{{ totalbeforegstamount }}</td>
        <td style="text-align: end; font-weight: bold; border: 1px solid #000;">{{ cgst }}</td>
        <td style="text-align: end; font-weight: bold; border: 1px solid #000;">{{ sgst }}</td>
        <td style="text-align: end; font-weight: bold; border: 1px solid #000;">{{ igst }}</td>
        <td style="text-align: end; font-weight: bold; border: 1px solid #000;">{{ gstcst }}</td>
        <td style="text-align: end; font-weight: bold; border: 1px solid #000;">{{ invoice_total }}</td>
        <td style="text-align: end; font-weight: bold; border: 1px solid #000;">{{ paidamount }}</td>
        <td style="text-align: end; font-weight: bold; border: 1px solid #000;">
          {{invoice_total - paidamount  }}
        </td>
      </tr>
    </tbody>
  </table>
</div>